var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "info--text text-uppercase my-3 mt-2" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.generateMessage("requests.details.titles.dangerousSituations")
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _vm.property.dangerous_situations_instructions.length > 0
      ? _c(
          "div",
          { staticClass: "d-flex flex-wrap" },
          [
            _c(
              "v-col",
              { attrs: { cols: "12" } },
              [
                _c("v-data-table", {
                  staticClass:
                    "secondarybackground striped-table clickable ma-2 caption",
                  attrs: {
                    dense: "",
                    loading: _vm.loading,
                    "hide-default-footer": "",
                    "fixed-header": "",
                    height: "155",
                    "disable-sort": "",
                    "disable-pagination": "",
                    items: _vm.property.dangerous_situations_instructions,
                    headers: _vm.listHeaders
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.tech_answer_datetime",
                        fn: function({ value }) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(new Date(value).toLocaleString()) +
                                "\n        "
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3092469542
                  )
                })
              ],
              1
            )
          ],
          1
        )
      : _c("div", { staticClass: "d-flex flex-wrap caption" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.generateMessage(
                  "requests.details.titles.noDangerousSituations"
                )
              ) +
              "\n  "
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }